import { sharedService } from "@/modules/shared/store/services/shared-service";
import { populateBankingTypes } from "@/redux/reducers/bankingTypesSlice";

const getBankingTypes = sharedService.injectEndpoints({
  endpoints: builder => ({
    getBankingTypes: builder.query({
      query: () => "parameters/banking-types",
      transformResponse: response => response.items,
      providesTags: ["BankingTypes"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(populateBankingTypes(data));
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetBankingTypesQuery } = getBankingTypes;

